export default "__VITE_ASSET__d5I2c1qi__"